module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAgVBMVEUAAACSbdubhemkie2hhuufiOihiOqfiu2giO2gieyhieyhi+2hieyhieyiiuyhiuyhi+2hieyhiuzWzPjXzPihiuzHufShiezw7fyvm+66qvHJu/T9/P+iiu3+/f+hiuyhiuz///+gieuhiuzQxPXWy/bb0vfh2vjn4frt6Pv////hwCS2AAAAInRSTlMABxccJi08SFZud3+gra/M5Obu8PDx8fPz9fX1+fv8/f7+mLsLXgAAAKlJREFUKM+9kscOgzAQROm9J/RiYOj//4GxFVBkiMIt77CS59mHWVkQblHcOHaVL3kESnQ1LjxJ8uBeRAxJECTEFwF85l+F6oQEOyR01CM3a3DU5js3WpJkzbbTZAlpDZaLAZ4bxwOBSIWOvONFl0OnwkK5nShhUWFjOIsB9iHWkZ7nmY5x5cTCXk0Tu73cChNFxYuqAKsop7Rs33MjlVlDzT+vxNd+fJoX918o0l646dcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/clear_history.png
// module id = 251
// module chunks = 1